import { InitialValues, SyncCustomDateSettingsType, SyncSettingsType } from "./types";

export const SYNC_SETTINGS_TYPES: SyncSettingsType = {
  untilCustomDate: "untilCustomDate",
  allTransferBatches: "allTransferBatches",
};

export const SYNC_CUSTOM_DATE_SETTINGS_TYPES: SyncCustomDateSettingsType = {
  untilLastSyncedGlDate: "untilLastSyncedGlDate",
  customGlDate: "customGlDate",
};

export const INITIAL_VALUES: InitialValues = {
  customGlDate: null,
  glStartDate: "",
  useInceptionDate: false,
  syncSettings: SYNC_SETTINGS_TYPES.allTransferBatches,
  syncCustomDateSettings: SYNC_CUSTOM_DATE_SETTINGS_TYPES.untilLastSyncedGlDate,
};
